import type { PaneBlock } from '@editorStores'

export const TENSILE_TRANSMISSION_FORM_BLOCK_ACTION = 'tensile-transmission-form'

/** While unsaved, the form refuses leaving its pane (other element, tab, mode, ESC, storey). */
export const TENSILE_TRANSMISSION_PANE_BLOCK: PaneBlock = {
  message:
    'Bitte speichern oder verwerfen Sie die Änderungen an den Zugverbindungen, bevor Sie fortfahren',
  options: {
    variant: 'warning',
    preventDuplicate: true,
    key: 'unsaved-tensile-transmission',
  },
}
